import type { IQueryArgs } from '@/types/apiTypes';
import useQueryHelpers from '@/composables/useQueryHelpers';

const { deepUnref } = useQueryHelpers();

export { taskKeys } from '@satellite/composables/queryKeys';

export const authKeys = {
  all: ['auth'] as const,
  me: () => [...authKeys.all, 'me'] as const
};

export const warehouseKeys = {
  all: ['warehouses'] as const,
  list: (queryArgs?: IQueryArgs) => [...warehouseKeys.all, 'list', deepUnref(queryArgs)] as const
};
